import type { KbSource } from '@af/shared';

/** Keep model citations as attribution metadata, outside the conversational answer. */
export function helpAnswer(text: string, sources: KbSource[]) {
  const cited = new Set<number>();
  const content = text
    .replace(/\[(\d+(?:\s*,\s*\d+)*)\](?!\()/g, (_, numbers: string) => {
      for (const n of numbers.split(',')) cited.add(Number(n.trim()));
      return '';
    })
    .replace(/ +([.,;:!?])/g, '$1');
  const seen = new Set<string>();
  const used = sources.filter((source) => {
    if (!cited.has(source.n) || seen.has(source.slug)) return false;
    seen.add(source.slug);
    return true;
  });
  return { content, sources: used };
}
